// Cloning of inert <template> markup with token substitution, used by the
// dynamic-list and environment/persona form components to add rows that
// match the server-rendered ones.

/**
 * Replace every occurrence of each substitution key in the text nodes and
 * attribute values beneath `node`.
 */
export function substituteTokens(node, substitutions) {
  if (node.nodeType === Node.TEXT_NODE) {
    let text = node.textContent;
    for (const [token, value] of Object.entries(substitutions)) {
      text = text.split(token).join(value);
    }
    node.textContent = text;
    return;
  }
  // A cloned <template> arrives as a DocumentFragment: no attributes of its
  // own, but its children still need walking.
  if (node.nodeType === Node.ELEMENT_NODE) {
    for (const attr of node.attributes) {
      let value = attr.value;
      for (const [token, replacement] of Object.entries(substitutions)) {
        value = value.split(token).join(replacement);
      }
      if (value !== attr.value) attr.value = value;
    }
  } else if (node.nodeType !== Node.DOCUMENT_FRAGMENT_NODE) {
    return;
  }
  for (const child of node.childNodes) {
    substituteTokens(child, substitutions);
  }
}

/** The <template> with this id; throws when the page does not render it. */
export function requireTemplate(id) {
  const template = document.getElementById(id);
  if (!(template instanceof HTMLTemplateElement)) {
    throw new Error(`Template not found: ${id}`);
  }
  return template;
}

/** A deep clone of the template's first element with tokens substituted. */
export function cloneTemplate(template, substitutions) {
  const fragment = template.content.cloneNode(true);
  substituteTokens(fragment, substitutions);
  const element = fragment.firstElementChild;
  if (!element) throw new Error(`Template is empty: ${template.id}`);
  return element;
}
